export default __webpack_public_path__ + "9c8c09ed0463034dc3480fc1eb36234b.png";